export default __webpack_public_path__ + "static/media/profile2.0a36a958.svg";